import React, { FC, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap-v5'
import { KTSVG } from '../../../../_metronic/helpers'
import { formatDateStrShort } from '../../../helpers/FormatDate'
import { getSuggestion } from '../../../services/suggestionService'

type Props = {
  open: boolean
  onClose: () => void
  suggestionId?: number
}

export const DetailSuggestionDrawer: FC<Props> = ({ open, onClose, suggestionId }) => {
  const [loading, setLoading] = useState(false)
  const [detail, setDetail] = useState<any>(null)

  useEffect(() => {
    if (open && suggestionId) {
      setLoading(true)
      getSuggestion(suggestionId)
        .then((res) => setDetail(res))
        .catch(() => setDetail(null))
        .finally(() => setLoading(false))
    } else {
      setDetail(null)
    }
  }, [open, suggestionId])

  const submitterName = detail?.submittedBy?.name || detail?.submittedBy?.email || '—'
  const submitterImage = detail?.submittedBy?.image
  const timesTaken = detail?.timesTaken ?? detail?.partnerProposals?.length ?? 0
  const proposals = detail?.partnerProposals || []
  const hasProposals = proposals.length > 0

  return (
    <Modal
      show={open}
      onHide={onClose}
      backdrop='static'
      dialogClassName='experience-detail-modal'
      contentClassName='experience-detail-modal-content'
      backdropClassName='experience-detail-backdrop'
      className='w-100'
    >
      <div className='admin-experience-details-container p-0'>
        <div style={{ width: '100%', height: '100%', padding: 40, background: 'white', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.08)', borderLeft: '1px #E9E9E9 solid', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'inline-flex' }}>
          
          {/* Header */}
          <div style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex' }}>
            <div style={{ flex: '1 1 0', color: '#151515', fontSize: 32, fontFamily: 'Oswald', fontWeight: '500', lineHeight: '38.40px' }}>
              Suggested Experiences Details
            </div>
            <div className='cursor-pointer' onClick={onClose} style={{ width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <KTSVG path='/media/svg/nobilis/closeX.svg' className='svg-icon-1' />
            </div>
          </div>

          {loading ? (
            <div className='text-center py-10 w-100'>
              <span className='spinner-border spinner-border-sm align-middle ms-2' /> Loading...
            </div>
          ) : detail ? (
            <div style={{ alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 10, display: 'flex' }}>
              <div style={{ alignSelf: 'stretch', padding: 30, background: 'white', outline: '1px #E9E9E9 solid', outlineOffset: '-1px', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 20, display: 'flex' }}>
                
                {/* ID & Times Taken */}
                <div style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex' }}>
                  <div style={{ flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 5, display: 'inline-flex' }}>
                    <div style={{ justifyContent: 'center', alignItems: 'center', gap: 10, display: 'inline-flex' }}>
                      <div style={{ color: '#808080', fontSize: 10, fontFamily: 'Satoshi', fontStyle: 'italic', fontWeight: '400', lineHeight: '14px' }}>
                        #{detail.id}
                      </div>
                    </div>
                  </div>
                  <div style={{ justifyContent: 'flex-start', alignItems: 'center', gap: 15, display: 'flex' }}>
                    <div style={{ color: '#151515', fontSize: 12, fontFamily: 'Satoshi', fontWeight: '300', lineHeight: '16.80px' }}>
                      {timesTaken} times taken
                    </div>
                  </div>
                </div>

                {/* Title & Description */}
                <div style={{ alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 10, display: 'flex' }}>
                  <div style={{ alignSelf: 'stretch', color: '#151515', fontSize: 12, fontFamily: 'Satoshi', fontWeight: '700', lineHeight: '16.80px' }}>
                    {detail.title}
                  </div>
                  <div style={{ alignSelf: 'stretch', color: '#151515', fontSize: 12, fontFamily: 'Satoshi', fontWeight: '300', lineHeight: '16.80px', whiteSpace: 'pre-line' }}>
                    {detail.description}
                  </div>
                </div>

                {/* Suggested by */}
                <div style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex' }}>
                  <div style={{ color: '#B4B4B4', fontSize: 10, fontFamily: 'Satoshi', fontWeight: '500', textTransform: 'uppercase', lineHeight: '18.50px', letterSpacing: '1.50px' }}>
                    Suggested by
                  </div>
                  <div style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, outline: '1px #E9E9E9 solid', outlineOffset: '-1px', justifyContent: 'flex-start', alignItems: 'center', gap: 15, display: 'flex' }}>
                    <div style={{ flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 10, display: 'inline-flex' }}>
                      <div style={{ alignSelf: 'stretch', justifyContent: 'flex-start', alignItems: 'center', gap: 10, display: 'inline-flex' }}>
                        {submitterImage ? (
                          <img style={{ width: 28, height: 28, borderRadius: 21, objectFit: 'cover' }} src={submitterImage} alt='' />
                        ) : (
                          <div style={{ width: 28, height: 28, borderRadius: 21, background: '#E9E9E9', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: '700' }}>
                            {submitterName.charAt(0).toUpperCase()}
                          </div>
                        )}
                        <div style={{ textAlign: 'center', color: '#151515', fontSize: 12, fontFamily: 'Cormorant SC', fontWeight: '500', lineHeight: '22.20px' }}>
                          {submitterName}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Wants to Lead */}
                <div style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex' }}>
                  <div style={{ color: '#B4B4B4', fontSize: 10, fontFamily: 'Satoshi', fontWeight: '500', textTransform: 'uppercase', lineHeight: '18.50px', letterSpacing: '1.50px' }}>
                    Wants to Lead
                  </div>
                  <div style={{ color: '#B4B4B4', fontSize: 10, fontFamily: 'Satoshi', fontWeight: '500', textTransform: 'uppercase', lineHeight: '18.50px', letterSpacing: '1.50px' }}>
                    {detail.wantsToLead ? 'Yes' : 'No'}
                  </div>
                </div>

                {/* partners proposals */}
                <div style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex' }}>
                  <div style={{ color: '#B4B4B4', fontSize: 10, fontFamily: 'Satoshi', fontWeight: '500', textTransform: 'uppercase', lineHeight: '18.50px', letterSpacing: '1.50px' }}>
                    partners proposals
                  </div>
                  <div style={{ color: '#B4B4B4', fontSize: 10, fontFamily: 'Satoshi', fontWeight: '500', textTransform: 'uppercase', lineHeight: '18.50px', letterSpacing: '1.50px' }}>
                    {hasProposals ? 'Yes' : 'No'}
                  </div>
                </div>

                {/* Proposals List Rows */}
                {proposals.map((prop: any, idx: number) => (
                  <div key={`proposal-${prop.id || idx}`} style={{ alignSelf: 'stretch', justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex' }}>
                    <div style={{ width: 42, justifyContent: 'flex-start', alignItems: 'center', gap: 10, display: 'flex' }}>
                      <div style={{ justifyContent: 'center', alignItems: 'center', gap: 10, display: 'flex' }}>
                        <div style={{ color: '#808080', fontSize: 10, fontFamily: 'Satoshi', fontStyle: 'italic', fontWeight: '400', lineHeight: '14px' }}>
                          #{prop.id}
                        </div>
                      </div>
                    </div>
                    <div style={{ width: 196, justifyContent: 'flex-start', alignItems: 'center', gap: 10, display: 'flex' }}>
                      <div style={{ width: 199, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 10, display: 'inline-flex' }}>
                        <div style={{ alignSelf: 'stretch', justifyContent: 'flex-start', alignItems: 'center', gap: 10, display: 'inline-flex' }}>
                          {prop.creatorImage ? (
                            <img style={{ width: 28, height: 28, borderRadius: 21, objectFit: 'cover' }} src={prop.creatorImage} alt='' />
                          ) : (
                            <div style={{ width: 28, height: 28, borderRadius: 21, background: '#151515', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: '700' }}>
                              {(prop.creatorName || 'E').charAt(0).toUpperCase()}
                            </div>
                          )}
                          <div style={{ textAlign: 'center', color: '#151515', fontSize: 12, fontFamily: 'Satoshi', fontWeight: '700', lineHeight: '16.80px' }}>
                            {prop.creatorName}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ width: 100, color: '#151515', fontSize: 12, fontFamily: 'Satoshi', fontWeight: '300', lineHeight: '16.80px' }}>
                      {prop.createdAt ? formatDateStrShort(prop.createdAt) : '—'}
                    </div>
                    <div style={{ width: 98, justifyContent: 'flex-start', alignItems: 'center', gap: 10, display: 'flex' }}>
                      <div style={{ color: '#151515', fontSize: 12, fontFamily: 'Satoshi', fontWeight: '400', lineHeight: '16.80px' }}>
                        {prop.statusDisplay || prop.status}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className='text-center py-10 text-muted w-100'>Suggestion details not found.</div>
          )}
        </div>
      </div>
    </Modal>
  )
}
